document.addEventListener('DOMContentLoaded', function() {
  /* Default expand first accordion option */
  $('.product .accordion').first().addClass('active');
  
  $('body').on('click','.accordion .accordion__title label, .accordion .accordion__title legend', function() {
    $(this).closest('.accordion').toggleClass('active');
  });
  $('body').on('click','.accordion .accordion__content label', function() {
    let variantClass = $(this).attr('class');
    let productTitle = $('.product__title > h1');
    let optionTitle = '';

    if(productTitle.find('span.'+variantClass).length == 0)
      productTitle.append('<span class="' + variantClass + '"></span>');
    else
      productTitle.children('span.'+variantClass).text('');
    
    if(variantClass=='opt-colour' || variantClass=='opt-colour-frames')
      optionTitle = $(this).children('.icon').attr('title');
    else
      optionTitle = $(this).children('.value').text();
    
    /* update & show selected option name */
    $(this).closest('.accordion').find('.option-picked').text(optionTitle);
    
    /* update & append selected option name after product title */
    productTitle.children('span.'+variantClass).text(', ' + optionTitle);
  });
  $('body').on('change','.accordion .accordion__content select', function() {
    $(this).closest('.accordion').find('.option-picked').text($(this).find("option:selected").text()); 
  });
});